import React from 'react'
import css from './Checkbox.css'
import MdCheckboxBlank from 'react-icons/lib/md/check-box-outline-blank';
import MdCheckbox from 'react-icons/lib/md/check-box';

const Checkbox = ({ checked, onCheck, ...props }) => (
  <label>
    {checked
    ?
    <MdCheckbox size={24} {...props} />
    :
    <MdCheckboxBlank size={24} {...props} />
    }
    <input
      type="checkbox"
      checked={checked}
      onChange={onCheck}
      style={{ display: 'none' }}
    />
  </label>
)

export default Checkbox


/** WEBPACK FOOTER **
 ** ./components/Checkbox.js
 **/